// extracted by mini-css-extract-plugin
export var borderRadius = "_9z-4";
export var large = "_9z-3";
export var logoContainer = "_9z-0";
export var nameLogo = "_9z-2";
export var small = "_9z-1";